
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"15","height":"15","viewBox":"0 0 15 15"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.493 14.5l.116-.174v-.106l1.601-.077s.062 0 .062-.101v-.449a.083.083 0 00-.072-.077l-1.447-.328c.217-.862.357-1.741.42-2.628V8.385c.108-.259.178-.531.207-.81h1.495l4.432-.304v-.555a.262.262 0 00-.304-.231l-3.858-.261h-.424a8.018 8.018 0 000-.877c.301.013.602.002.902-.034a5.681 5.681 0 00-.921-.048.21.21 0 00-.184-.305.208.208 0 00-.183.305 5.67 5.67 0 00-.921.048c.299.036.601.047.902.034a7.854 7.854 0 000 .868H8.39a.887.887 0 00-.203-.685V1.836S8.047.5 7.541.5c-.482 0-.646 1.336-.646 1.336V5.53a.887.887 0 00-.203.685h-.926a7.854 7.854 0 000-.868c.301.013.603.002.902-.034a5.67 5.67 0 00-.921-.048.209.209 0 00-.183-.305.21.21 0 00-.184.305 5.681 5.681 0 00-.921.048c.3.036.601.047.902.034a8.018 8.018 0 000 .877h-.506l-3.858.261a.262.262 0 00-.304.231v.55l4.432.304H6.62c.029.279.099.552.207.81v2.175c.063.887.203 1.766.42 2.628l-1.447.328a.083.083 0 00-.072.078v.448c0 .106.062.101.062.101l1.553.077v.102l.15.183z"}})])
          )
        }
      }
    